//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import Comments from "../../../components/Flow/comments.vue";

export default {
    name: "QfMAppComments",
    components: { Comments, AQModal },
    props: {
        actionsList: Array,
        processInstance: String,
        applicationId: String,
        isSmallScreen: { type: Boolean, default: false }
    },
    data() {
        return {
            localShow: true
        };
    },
    methods: {
        modalAction(action) {
            if (action === "close") {
                this.localShow = false;
            }
        },
        modalAfterHide() {
            this.$emit("input", false);
        }
    }
};
